import React from "react";
import i18n from "i18next";

export function HtmlContent(base) {
  return {
    getConfig: function () {
      return {
        name: "HtmlContent",
        displayName: IdealStudio.i18n.t("HtmlContent.PluginName") || "HTML Content",
        category: "multimedia",
        needsConfigModal: false,
        needsTextEdition: false,
        initialWidth: "auto",
        initialWidthSlide: "50%",
        initialHeightSlide: "40%",
        icon: "code",
        flavor: "plain",
      };
    },
    getRenderTemplate: function (state) {
      // No need to parse HTML content it is render from _html state, child plugins will be add later
      return null;
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            style: {
              __name: IdealStudio.i18n.t("BasicText.box_style") || "Style",
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("BasicText.padding") || "Padding",
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("BasicText.background_color") || "Background Color",
                  type: "color",
                  value: "rgba(255,255,255,0)",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("BasicText.border_size") || "Border Size",
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("BasicText.border_style") || "Border Style",
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("BasicText.border_color") || "Border Color",
                  type: "color",
                  value: "#000000",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("BasicText.radius") || "Radius",
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("BasicText.opacity") || "Opacity",
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
  };
}
